import * as React from 'react';
import Small from 'UIComponents/elements/Small';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const WalmartAbstractFilterRenderer = ({
  heading,
  filterLine
}) => {
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(Small, {
      use: "help",
      children: heading
    }), /*#__PURE__*/_jsx("br", {}), filterLine]
  });
};
export default WalmartAbstractFilterRenderer;